import { render, staticRenderFns } from "./applyDetails.vue?vue&type=template&id=07cf472b&scoped=true&"
import script from "./applyDetails.vue?vue&type=script&lang=js&"
export * from "./applyDetails.vue?vue&type=script&lang=js&"
import style0 from "./applyDetails.vue?vue&type=style&index=0&id=07cf472b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cf472b",
  null
  
)

export default component.exports